/**
 * Files that need attention: those missing any association of a required
 * object type. The caller passes the required ids it already holds (from
 * relay's useRequiredAssociationTypes); an empty set yields no results,
 * mirroring the thread confirm gate.
 */

import {useFiles} from './useFiles';

export function useNeedsAttentionFiles(requiredObjectTypeIds: string[]) {
  return useFiles({
    missingRequiredAssociation: true,
    requiredObjectTypeIds,
  });
}
